import React, { useState, useEffect } from "react";
import { aprobarSolicitudVacanteApi, guardarVacanteApi, guardadoParcialApi } from "../api/contratacion/solicitudVacanteApi";
import { modalDeclinarSolicitud, modalDeclinarProceso, mensajeSimple, modalCargando, HtmlList } from "./ui/sweetAlerts";
import { PERSONA_VALORES_INICIALES, txtMensajeDatosIngresados, DOCUMENTOS } from "../utils/Constants.js";
import { guardarDatosPersonaExtranjeraApi } from "../api/contratacion/datosPersonaExtranjeraApi";
import FormDatosLaborales from "./procesoContratacion/datosLaborales/FormDatosLaborales.jsx";
import { guardarDatosPersonalesApi } from "../api/contratacion/datosPersonalesApi";
import { guardarDatosPrevisionApi } from "../api/contratacion/datosPrevisionApi";
import { guardarDatosBancariosApi } from "../api/contratacion/datosBancariosApi";
import { guardarDatosLaboralesApi } from "../api/contratacion/datosLaboralesApi";
import { guardarDireccionApi } from "../api/contratacion/datosDireccionApi";
import FormDatosPersonales from "./procesoContratacion/FormDatosPersonales";
import FormDatosPrevision from "./procesoContratacion/FormDatosPrevision";
import FormDatosBancarios from "./procesoContratacion/FormDatosBancarios";
import FormDatosDireccion from "./procesoContratacion/FormDatosDireccion";
import { guardarDatosSaludApi } from "../api/contratacion/datosSaludApi";
import { guardarDocumentoApi } from "../api/contratacion/documentosApi";
import { SubirDataTemporalApi } from "../api/listas/temporisApi.js";
import { useContratacionScreen } from "./useContratacionScreen.js";
import FormDocumentos from "./procesoContratacion/FormDocumentos";
import { useNavigate, useParams } from "react-router-dom";
import { SpinnerModal } from "./ui/Spinner";
import { getUno, post } from "../api/apis";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import PropTypes from "prop-types";

const PageDisplay = ({ page, bloqueado, formik }) => {
  if (page === 0) {
    return <FormDatosLaborales bloqueado={bloqueado} formik={formik} />;
  }
  if (page === 1) {
    return <FormDatosPersonales formik={formik} />;
  }
  if (page === 2) {
    return <FormDatosDireccion formik={formik} />;
  }
  if (page === 3) {
    return <FormDatosPrevision formik={formik} />;
  }
  if (page === 4) {
    return <FormDatosBancarios formik={formik} />;
  }
  if (page === 5) {
    return <FormDocumentos formik={formik} />;
  }
};

PageDisplay.propTypes = {
  page: PropTypes.number.isRequired,
  bloqueado: PropTypes.bool,
  formik: PropTypes.object,
};

const FormContratacionScreen = () => {
  const [listaGuardado, setListaGuardado] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleSpinner, setVisibleSpinner] = useState(true);
  const [txtSpinner, setTxtSpinner] = useState("");
  const { idPersona } = useParams();
  const navigate = useNavigate();
  const msjCorrecto = ", guardado correctamente.";
  const msjIncorrecto = ", no se pudo guardar.";

  const titulosFormulario = ["Datos Laborales", "Datos Personales", "Datos de dirección", "Datos de previsión", "Datos bancarios", "Documentos / Soporte de contratación"];
  const { validate, siguenteVista, bloqueado, page, setearPagina, verHabilitado, returnPorcentaje } = useContratacionScreen();


  function setearMensaje(tipo, resp, extraData = null) {
    let dataObj = {};
    const isSuccess = Boolean(resp?.status === "success");

    if (resp) {
      if (resp.data && !Array.isArray(resp.data) && Object.keys(resp.data).length > 0) {
        dataObj = { ...resp.data };
      } else if (resp.message) {
        dataObj = { Mensaje: resp.message };
      }
    } else {
      resp = { status: "error", message: "Error de red o sin respuesta" };
    }

    if (extraData) {
      dataObj = { ...extraData, ...dataObj };
    }

    setListaGuardado(listaGuardado => [
      ...listaGuardado,
      {
        icono: isSuccess ? "check.png" : "warning.png",
        texto: `${tipo}${isSuccess ? msjCorrecto : msjIncorrecto}`,
        Tooltip: isSuccess ? "" : (resp.message || "No se pudo guardar la información"),
        data: dataObj,
        isSuccess: isSuccess,
      },
    ]);
  }

  async function getUnaPersona(id) {
    const respPersona = await getUno("persona", { idPersona: id });
    const { apellido_mat, apellido_pat, correo, fecha_nacimiento, id_educacion_nivel, id_persona_estado_civil, id_persona_genero, identificacion, nombre } = respPersona.data.data;

    formik.setValues({
      ...formik.values,
      datosPersonales: {
        apellidoMaterno: apellido_mat,
        apellidoPaterno: apellido_pat,
        email: correo,
        estadoCivil: id_persona_estado_civil,
        sexo: id_persona_genero,
        nombres: nombre,
        nivelFormacion: id_educacion_nivel || "",
        rut: identificacion,
        fechaNacimiento: fecha_nacimiento === null || fecha_nacimiento === "None" ? "" : fecha_nacimiento,
        telefonoCelular: "",
      },
    });
  }

  useEffect(() => {
    if (!localStorage.getItem("rut")) {
      mensajeSimple("info", "No existe un rut asociado al proceso, será redireccionado", 3500);
      setTimeout(() => {
        navigate("/consulta-rut");
      }, 3500);
    }
    if (idPersona) {
      getUnaPersona(idPersona);
    }
  }, []);

  const guardarNuevosDatos = async (valores, personaSolicitante = false, editaVacante = true) => {
    setVisibleModal(!visibleModal);
    localStorage.removeItem("rut");

    const idPersona = await guardarDatosPersonaYRelacionados(valores, page, setTxtSpinner, setearMensaje);
    await guardarDocumentos(valores, page, idPersona, setTxtSpinner, setearMensaje);
    await guardarSolicitudYDatosLaborales({ valores, personaSolicitante, editaVacante, pagina: page, titulosFormulario, idPersona, actualizarSpinner: setTxtSpinner, registrarMensaje: setearMensaje });
    setVisibleSpinner(!visibleSpinner);
  };

  const personaSolicitante = useSelector(store => store.datosPersonaSolicitante.dataPersona);
  const guardarProcesoDeContratacion = values => {
    guardarNuevosDatos(values, personaSolicitante);
  };

  const formik = useFormik({
    initialValues: PERSONA_VALORES_INICIALES(personaSolicitante),
    enableReinitialize: true,
    validateOnMount: true,
    validate,
    onSubmit: values => {
      guardarProcesoDeContratacion(values);
    },
  });

  const disabledButtonNext = () => (formik.dirty ? verHabilitado(page, formik.errors) : true);

  const resetValores = arr => {
    arr.forEach(el => formik.setFieldValue(`datosDocumentos.${el}`, null));
  };

  const declinar = () => {
    localStorage.setItem("page", Number.parseInt(page) - 1);
    setearPagina(currentPage => currentPage - 1);
    resetValores(["curriculum", "cedula", "antecedentes", "residencia", "afp", "salud", "visa", "discapacidad", "covid", "jubilacion"]);
  };

  const funcionMostrarModal = () => {
    let mostrar = false;
    Object.values(formik.values.datosDocumentos).forEach(el => {
      if (el !== null) {
        mostrar = true;
      }
    });
    return mostrar;
  };

  const Preguardadotemporal = async formik => {
    if (!(await evaluaCorreoActivo(formik.datosPersonales.email))) {
      return;
    }
    guardarProcesoDeContratacion(formik);
  };

  const continuarProceso = async (pagina, titulosFormulario, formulario) => {
    if (pagina != 1) {
      siguenteVista(pagina, titulosFormulario, formulario);
      return;
    }
    //aca llamar endpoint
    if (!(await evaluaCorreoActivo(formulario.values.datosPersonales.email))) {
      return;
    }
    siguenteVista(pagina, titulosFormulario, formulario);
  };

  const evaluaCorreoActivo = async email => {
    modalCargando("Verificando email...");
    const resp = await post("verificacorreousuarioactivo", "", { email: email });
    if (resp?.data?.status === "info") {
      mensajeSimple("error", resp.data.message, 2500);
      return false;
    }
    if (!resp?.data || resp?.data?.status !== "success") {
      mensajeSimple("error", "No se pudo verificar el correo o la sesión ha expirado", 2500);
      return false;
    }
    mensajeSimple("success", "Email permitido", 1500);
    return true;
  };

  const evaluarRetorno = () => {
    if (funcionMostrarModal()) {
      modalDeclinarProceso(declinar);
    } else {
      localStorage.setItem("page", Number.parseInt(page) - 1);
      setearPagina(currentPage => currentPage - 1);
    }
  };

  const declinarSolicitud = async codPosicion => {
    const { fechaIngreso, cargo } = formik.values.datosLaborales;
    const resp = await post("desbloqueoposicion", { codPosicion: JSON.parse(cargo).MOES_COD_POSICION, fechaInicio: fechaIngreso });

    if (resp.data.status === "info") {
      mensajeSimple("error", "La posición no pudo ser liberada.", 2500);
    } else if (resp.data.status === "success") {
      mensajeSimple(resp.data.status, resp.data.message, 5000);
      setTimeout(() => {
        localStorage.setItem("page", 0);
        setearPagina(0);
        if (page !== 1) {
          navigate("/consulta-rut");
        }
      }, 5000);
    } else {
      mensajeSimple("error", "Ha ocurrido un error.");
    }
  };

  useEffect(() => {
    disabledButtonNext();
  }, [page]);

  useEffect(() => {
    formik.setErrors(validate(formik.values));
  }, [formik.values]);

  return (
    <>
      <Modal show={visibleModal} centered scrollable size="lg">
        <HtmlList lista={listaGuardado} />

        {visibleSpinner && <SpinnerModal txt={txtSpinner} />}

        {!visibleSpinner && (
          <div className="text-center">
            <button
              className="btnArcoprime mb-4 mt-2"
              onClick={() => {
                setVisibleSpinner(!visibleSpinner);
                setVisibleModal(!visibleModal);
                window.location = "/";
              }}
            >
              Entendido
            </button>
          </div>
        )}
      </Modal>
      <div className="form mx-5">
        <div className="form-container mx-5">
          <div className="header">
            <div className="progress my-3">
              <div className="progress-bar progress-bar-striped progress-bar-animated" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={returnPorcentaje(page)}></div>
            </div>
            <div className=" d-flex justify-content-between align-items-baseline">
              <div>
                <h1 className="mb-0"> {titulosFormulario[page]} </h1>
                <span className="mt-0" style={{ weight: "700" }}>
                  Campos requeridos poseen este símbolo (*)
                </span>
              </div>
            </div>
          </div>

          <div className="body">
            <PageDisplay page={page} bloqueado={bloqueado} formik={formik} />
          </div>
          <div className="footer mb-5">
            <div className="float-end">
              {page < titulosFormulario.length - 1 && page > 0 && (
                <button
                  className="btn btn-success mt-4 me-2"
                  type="button"
                  disabled={disabledButtonNext()}
                  onClick={() => {
                    Preguardadotemporal(formik.values);
                  }}
                >
                  Guardado temporal
                </button>
              )}
              {bloqueado && page !== 0 && (
                <button
                  className="btn btn-danger align-items-center mt-4 me-5 candadoPosicion"
                  onClick={() => {
                    const { cargo } = formik.values.datosLaborales;
                    modalDeclinarSolicitud(declinarSolicitud, JSON.parse(cargo).MOES_COD_POSICION, `¿Está seguro de liberar la posición? Se perderá el proceso actual y la posición <b>${JSON.parse(cargo).MOES_COD_POSICION} - ${JSON.parse(cargo).MOES_DESCRIPCION_POSICION}</b> estará disponible nuevamente.`);
                  }}
                >
                  Declinar solicitud
                </button>
              )}
              <button
                className="btn btn-outline-primary mt-4 me-2"
                onClick={() => {
                  if (page === 0) {
                    navigate("/consulta-rut");
                  } else if (page === 1 && bloqueado) {
                    const { cargo } = formik.values.datosLaborales;
                    modalDeclinarSolicitud(declinarSolicitud, JSON.parse(cargo).MOES_COD_POSICION, txtMensajeDatosIngresados);
                  } else if (page === 5) {
                    evaluarRetorno();
                  } else {
                    localStorage.setItem("page", Number.parseInt(page) - 1);
                    setearPagina(currentPage => currentPage - 1);
                  }
                }}
              >
                Ir atrás
              </button>
              <button
                id="btnContinuarContratacion"
                disabled={disabledButtonNext()}
                className={page === titulosFormulario.length - 1 ? `btn btn-success mt-4 ` : `btn btn-primary mt-4 `}
                onClick={() => {
                  continuarProceso(page, titulosFormulario.length - 1, formik);
                }}
              >
                {page === titulosFormulario.length - 1 ? "Enviar a Aprobación" : "Continuar"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormContratacionScreen;

async function guardarDatosPersonaYRelacionados(valores, pagina, actualizarSpinner, registrarMensaje) {
  actualizarSpinner("Datos personales");
  const rutPersona = valores.datosPersonales.rut || localStorage.getItem("rut");
  if (rutPersona) { localStorage.setItem("rut", rutPersona); }
  const datosPersonales = { ...valores.datosPersonales, rut: rutPersona };
  const nombrePersona = `${valores.datosPersonales.nombres || ""} ${valores.datosPersonales.apellidoPaterno || ""} ${valores.datosPersonales.apellidoMaterno || ""}`.trim();
  const respuestaPersona = await guardarDatosPersonalesApi(datosPersonales);
  registrarMensaje("Datos personales", respuestaPersona, { persona: nombrePersona });

  const idPersona = respuestaPersona.data.id_persona;
  await guardarDatosPersonaExtranjera(valores, idPersona, actualizarSpinner, registrarMensaje);
  await guardarDireccion(valores, pagina, idPersona, actualizarSpinner, registrarMensaje);
  await guardarPrevisionYSalud(valores, pagina, idPersona, actualizarSpinner, registrarMensaje);
  await guardarDatosBancarios(valores, pagina, idPersona, actualizarSpinner, registrarMensaje);

  return idPersona;
}

async function guardarDatosPersonaExtranjera(valores, idPersona, actualizarSpinner, registrarMensaje) {
  if (valores.datosPersonales.nacionalidad === "1") return;

  actualizarSpinner("Datos persona extranjera");
  const respuestaExtranjero = await guardarDatosPersonaExtranjeraApi(valores.datosPersonaExtranjera, idPersona);
  registrarMensaje("Datos persona extranjera", respuestaExtranjero);
}

async function guardarDireccion(valores, pagina, idPersona, actualizarSpinner, registrarMensaje) {
  if (pagina < 2) return;

  actualizarSpinner("Datos dirección");
  const respuestaDireccion = await guardarDireccionApi(valores.datosDireccion, idPersona);
  registrarMensaje("Datos dirección", respuestaDireccion);
}

async function guardarPrevisionYSalud(valores, pagina, idPersona, actualizarSpinner, registrarMensaje) {
  if (pagina < 3) return;

  actualizarSpinner("Datos previsión");
  const respuestaPrevision = await guardarDatosPrevisionApi(valores.datosPrevision, idPersona);
  registrarMensaje("Datos previsión", respuestaPrevision);

  actualizarSpinner("Datos salud");
  const respuestaSalud = await guardarDatosSaludApi(valores.datosPrevision, idPersona);
  registrarMensaje("Datos salud", respuestaSalud);
}

async function guardarDatosBancarios(valores, pagina, idPersona, actualizarSpinner, registrarMensaje) {
  if (pagina < 4) return;

  actualizarSpinner("Datos bancarios");
  const respuestaBancaria = await guardarDatosBancariosApi(valores.datosBancarios, idPersona);
  registrarMensaje("Datos bancarios", respuestaBancaria);
}

async function guardarDocumentos(valores, pagina, idPersona, actualizarSpinner, registrarMensaje) {
  if (pagina !== 5) return;

  actualizarSpinner("Documentos");
  const documentosSeleccionados = DOCUMENTOS.filter(documento => valores.datosDocumentos[documento.documento] !== null);
  const resultadosDocumentos = await Promise.all(documentosSeleccionados.map(documento => guardarDocumento(documento, valores, idPersona)));
  const detallesDocumentos = resultadosDocumentos.reduce((detalles, resultado) => {
    detalles[resultado.nombreMensaje] = resultado.detalle;
    return detalles;
  }, {});

  procesarDocumentos(resultadosDocumentos, registrarMensaje, detallesDocumentos);
}

async function guardarDocumento(documento, valores, idPersona) {
  const archivo = valores.datosDocumentos[documento.documento];
  const respuestaDocumento = await guardarDocumentoApi(archivo, idPersona, documento.id_tipo);
  const esExitoso = respuestaDocumento?.status === "success";
  const rutaDocumento = respuestaDocumento?.data?.path_aws || respuestaDocumento?.data?.dir || (archivo?.[0]?.name ? `Archivo: ${archivo[0].name}` : "Guardado con éxito");

  return {
    nombreMensaje: documento.nombre_mensaje,
    esExitoso,
    detalle: esExitoso ? rutaDocumento : (respuestaDocumento?.message || "No se pudo guardar"),
  };
}

function procesarDocumentos(resultadosDocumentos, registrarMensaje, detallesDocumentos) {
  const hayDocumentos = resultadosDocumentos.length > 0;
  const todosExitosos = resultadosDocumentos.every(resultado => resultado.esExitoso);

  if (hayDocumentos) {
    const respDocs = {
      status: todosExitosos ? "success" : "error",
      message: todosExitosos ? "Documentos guardados correctamente" : "Ocurrió un problema al guardar algunos documentos",
    };
    registrarMensaje("Documentos", respDocs, detallesDocumentos);
  }
}

async function guardarSolicitudYDatosLaborales({ valores, personaSolicitante, editaVacante, pagina, titulosFormulario, idPersona, actualizarSpinner, registrarMensaje }) {
  if (!personaSolicitante || !editaVacante) return;

  const resultadoSolicitud = await procesarSolicitud({ personaSolicitante, actualizarSpinner, pagina, titulosFormulario, idPersona, valores, registrarMensaje });
  if (!resultadoSolicitud.ingresarDatosLaborales && !personaSolicitante.idSolicitud) return;

  const idSolicitud = personaSolicitante.idSolicitud || resultadoSolicitud.respuestaSolicitud.data.id_solicitud;
  actualizarSpinner("Datos laborales");
  const respuestaLaboral = await guardarDatosLaboralesApi(valores.datosLaborales, idSolicitud);
  registrarMensaje("Datos laborales", respuestaLaboral);
  await finalizarSolicitud({ personaSolicitante, pagina, idPersona, idSolicitud, respuestaLaboral, actualizarSpinner, registrarMensaje });
}

async function procesarSolicitud({ personaSolicitante, actualizarSpinner, pagina, titulosFormulario, idPersona, valores, registrarMensaje }) {
  if (personaSolicitante.idSolicitud) return { respuestaSolicitud: null, ingresarDatosLaborales: false };

  actualizarSpinner("Solicitud");
  const respuestaSolicitud = pagina < titulosFormulario.length - 1 && pagina >= 0
    ? await guardadoParcialApi(idPersona, 1, pagina, valores)
    : await guardarVacanteApi(idPersona, 1, 0, valores);
  registrarMensaje("Solicitud", respuestaSolicitud);

  return { respuestaSolicitud, ingresarDatosLaborales: respuestaSolicitud.status === "success" };
}

async function finalizarSolicitud({ personaSolicitante, pagina, idPersona, idSolicitud, respuestaLaboral, actualizarSpinner, registrarMensaje }) {
  if (personaSolicitante.idSolicitud && pagina === 5) {
    actualizarSpinner("Vacante");
    const respuestaSolicitante = await aprobarSolicitudVacanteApi(idSolicitud);
    registrarMensaje("Vacante", respuestaSolicitante);
  }

  if (respuestaLaboral.status !== "success") return;
  if (pagina === 5) await enviarDatosSistemasExternos(idPersona, idSolicitud, actualizarSpinner, registrarMensaje);
  setTimeout(() => {
    localStorage.removeItem("rut");
    window.location = "/";
  }, 300000);
}

async function enviarDatosSistemasExternos(idPersona, idSolicitud, actualizarSpinner, registrarMensaje) {
  actualizarSpinner("Envío a Temporis");
  const respuestaTemporis = await post("vacante/enviar_temporis", { id_solicitud: idSolicitud, idUsuario: idPersona });
  const esTemporisExitoso = respuestaTemporis?.status === "success" && !String(respuestaTemporis?.data?.data_temporis?.message || "").includes("false");
  registrarMensaje("Envío a Temporis", {
    status: esTemporisExitoso ? "success" : "error",
    message: esTemporisExitoso ? "Enviado a Temporis correctamente" : "No se pudo realizar el envío a Temporis (Fallo de autenticación o respuesta del servicio)",
  });

  actualizarSpinner("Datos temporales Intranet y SAP");
  const respuestaTemporal = await SubirDataTemporalApi(idPersona, idSolicitud);
  registrarResultadoSistema("Intranet", respuestaTemporal, registrarMensaje);
  registrarResultadoSistema("SAP", respuestaTemporal, registrarMensaje);
}

function registrarResultadoSistema(nombreSistema, respuestaTemporal, registrarMensaje) {
  const resultadoSistema = respuestaTemporal?.data?.[nombreSistema.toLowerCase()];
  const esExitoso = respuestaTemporal?.status === "success" || resultadoSistema?.status === "success";
  const mensajes = {
    Intranet: esExitoso ? "Datos creados en Intranet (qa.miviaje.cl) exitosamente" : (resultadoSistema?.message || "Error al enviar los datos a Intranet (qa.miviaje.cl)"),
    SAP: esExitoso ? "Datos temporales enviados a SAP (172.16.3.35) exitosamente" : (resultadoSistema?.message || "Tiempo de espera agotado o error al conectar con el servidor SAP (172.16.3.35:44300)"),
  };

  registrarMensaje(`Datos temporales ${nombreSistema}`, { status: esExitoso ? "success" : "error", message: mensajes[nombreSistema] });
}

